import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DatePipe } from '@angular/common';
import { AccLedgarMaster } from './Model/Account/AccLedgarMaster';
import { AccLedgerGroupmaster } from './Model/Account/AccLedgerGroupmaster';
import { Texpense } from './Model/Account/Texpense';
import { TripChallan } from './Model/Account/TripChallan';
import { TripExpense } from './Model/Account/TripExpense';
import { VehicleExpense } from './Model/Account/VehicleExpense';
import { VExpense } from './Model/Account/VExpense';
import { VoucherEntry } from './Model/Account/VoucherEntry';
import { ACCVEHTYPES } from './Model/ACCVEHTYPES';
import { Applicationcl } from './Model/Applicationcl';
import { BankMaster } from './Model/BankMaster';
import { Billers } from './Model/Billers';
import { BrokerMaster } from './Model/BrokerMaster';
import { BulkDeliveryInput } from './Model/BulkDeliveryInput';
import { Challan } from './Model/Challan';
import { City } from './Model/City';
import { ConsignmentDelivery } from './Model/ConsignmentDelivery';
import { Dashboard } from './Model/Dashboard';
import { DriverMaster } from './Model/DriverMaster';
import { EmailPartyBill } from './Model/EmailPartyBill';
import { EmailSetup } from './Model/EmailSetup';
import { EmployeeMaster } from './Model/EmployeeMaster';
import { Events } from './Model/Events';
import { EwayBill } from './Model/EwayBill';
import { EwayItemList } from './Model/EwayItemList';
import { EwayVehiclListDetail } from './Model/EwayVehiclListDetail';
import { ExtendEwayBill } from './Model/ExtendEwayBill';
import { ForgotPassword } from './Model/ForgotPassword';
import { Gpsdata } from './Model/Gpsdata';
import { GRBill } from './Model/GRBill';
import { GRBooking } from './Model/GRBooking';
import { Greentaxftl } from './Model/Greentaxftl';
import { GreentaxSlab } from './Model/GreentaxSlab';
import { LHContract } from './Model/LHContract';
import { LocationMaster } from './Model/LocationMaster';
import { Login } from './Model/Login';
import { MAXID } from './Model/MAXID';
import { MREntry } from './Model/MREntry';
import { PartyMaster } from './Model/PartyMaster';
import { PartySuppliers } from './Model/PartySuppliers';
import { RoleMaster } from './Model/RoleMaster';
import { Trpaccpartno } from './Model/Trpaccpartno';
import { Trpcharges } from './Model/Trpcharges';
import { Trpconsignment } from './Model/Trpconsignment';
import { Trpconsignmentinv } from './Model/Trpconsignmentinv';
import { Trpdbmrgr } from './Model/Trpdbmrgr';
import { Trpdbvoucher } from './Model/Trpdbvoucher';
import { Trpdbvoucherdetail } from './Model/Trpdbvoucherdetail';
import { Trpmstbill } from './Model/Trpmstbill';
import { TrpmstbillDetail } from './Model/TrpmstbillDetail';
import { TrpPaidTopaycharge } from './Model/TrpPaidTopaycharge';
import { TrpTruckkArrival } from './Model/TrpTruckkArrival';
import { TrpTruckkArrivalDetail } from './Model/TrpTruckkArrivalDetail';
import { Trptvcharges } from './Model/Trpvtcharges';
import { TRP_COMPANY_SETUP } from './Model/TRP_COMPANY_SETUP';
import { UserMaster } from './Model/UserMaster';
import { Vchalan } from './Model/Vchalan';
import { VchalanDetail } from './Model/VchalanDetail';
import { VehicleMaster } from './Model/VehicleMaster';
import { VenderMaster } from './Model/VenderMaster';
import { AutoLogoutService } from './service/auto-logout.service';
import { CommonService } from './service/CommonService';
import { ExcelServicesService } from './service/excel-services.service';
import { GRbookingervice } from './service/GRbookingservice';
import { LookupService } from './service/LookupService';
import { MasterConfigrationService } from './service/MasterConfigrationService';
import { PagerService } from './service/pager-service.service';
import { UserService } from './service/user.service';
import { VehicleChalanService } from './service/VehicleChalanService';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PartyUser } from './Model/PartyUser';
import { GRbookingComponent } from './GR/GRbooking.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { HttpModule } from '@angular/http';
import { MatInputModule, MatNativeDateModule } from '@angular/material';
import { AgGridModule } from 'ag-grid-angular';
import { AlertsModule } from 'angular-alert-module';
import { AngularDraggableModule } from 'angular2-draggable';
import { TrackandtraceComponent } from './trackandtrace/trackandtrace.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { LedgerreportComponent } from './ledgerreport/ledgerreport.component';

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  { path: 'grbooking', component: GRbookingComponent },
  { path: 'TrackBooking', component: TrackandtraceComponent },
  { path:'ledgerreport', component:LedgerreportComponent},
  { path: 'userconfigration/changepassword', component: ChangepasswordComponent }

]

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent, GRbookingComponent, LedgerreportComponent, TrackandtraceComponent, ChangepasswordComponent
  ],
  imports: [ BrowserModule,
    FormsModule, ReactiveFormsModule, BrowserAnimationsModule, MatAutocompleteModule, MatInputModule,
    MatDatepickerModule, MatNativeDateModule, MatProgressBarModule, MatProgressSpinnerModule, HttpClientModule, HttpModule,
    AngularDraggableModule,
    RouterModule.forRoot(routes),
    AlertsModule.forRoot(),
    AgGridModule.withComponents([])
    , RouterModule.forRoot(routes, { useHash: true })
  ],
  providers: [ DatePipe, UserService, CommonService, AutoLogoutService, PagerService, MasterConfigrationService,
    GRbookingervice, ExcelServicesService, VehicleChalanService, Trptvcharges, Trpcharges, Trpaccpartno, UserMaster, ConsignmentDelivery, Trpdbvoucher,
    Login, PartyMaster, MAXID, Billers, VehicleMaster, DriverMaster, BrokerMaster, Vchalan, EmployeeMaster, Trpdbmrgr, MREntry,
    TrpTruckkArrivalDetail, Applicationcl, RoleMaster, TrpPaidTopaycharge, Greentaxftl,
    TrpTruckkArrival, VenderMaster, LHContract, Trpmstbill, TrpmstbillDetail, GRBill, Challan, VchalanDetail,
    City, ACCVEHTYPES, PartySuppliers, LocationMaster, BankMaster, Trpconsignment, Trpconsignmentinv, Trpcharges, GreentaxSlab,
    GRBooking, AccLedgerGroupmaster, AccLedgarMaster, VoucherEntry, Trpdbvoucherdetail, TRP_COMPANY_SETUP,
    TripExpense, TripChallan, Texpense, Gpsdata, EmailSetup, EmailPartyBill, VExpense, VehicleExpense, Dashboard,
    EwayBill, LookupService, ExtendEwayBill, EwayVehiclListDetail, EwayItemList, BulkDeliveryInput, ForgotPassword,
    Events, PartyUser ],
  exports: [

  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
